import { RouteName, RouteParams } from '../../../../shared/utilities/routing/routing';
import { PickDomain } from '../../../../shared/utilities/types/PickDomain';
import { SearchSuggestion } from '../types/searchSuggestions';

type SearchSuggestionForUrl = PickDomain<
    SearchSuggestion,
    'type' | 'id' | 'slug',
    {
        parentDestinationSlug: SearchSuggestion['parentDestinationSlug'] | null;
    }
>;

export function buildSearchSuggestionUrl(
    suggestion: SearchSuggestionForUrl,
    generatePath: (name: RouteName, params?: RouteParams) => string,
): string | null {
    switch (suggestion.type) {
        case 'destination':
            return generatePath('destination', { destinationSlug: suggestion.slug });
        case 'region':
            if (!suggestion.parentDestinationSlug) return null;
            return generatePath('region', {
                destinationSlug: suggestion.parentDestinationSlug,
                regionSlug: suggestion.slug,
            });
        case 'place':
            if (!suggestion.parentDestinationSlug) return null;
            return generatePath('place', {
                destinationSlug: suggestion.parentDestinationSlug,
                placeId: String(suggestion.id),
                placeSlug: suggestion.slug,
            });
    }
}
